import PropTypes from "prop-types"

export const FACTOR = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  original: PropTypes.number,
  rebalanced: PropTypes.number,
  delta: PropTypes.number,
  formatter: PropTypes.func.isRequired,
})

export const CATEGORY = PropTypes.shape({
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  singleFactor: PropTypes.bool,
  original: PropTypes.number,
  rebalanced: PropTypes.number,
  delta: PropTypes.number,
  factors: PropTypes.arrayOf(FACTOR).isRequired,
  formatter: PropTypes.func.isRequired,
})
